import { memo } from 'react'

const options = [
  { children: 'Last 7 Days', value: 'last7Days' },
  { children: 'Last 30 Days', value: 'last30Days' },
  { children: 'Last 3 Months', value: 'last90Days' },
  { children: 'Last 6 Months', value: 'last180Days' },
  { children: 'Month to Date', value: 'monthToDate' }
]

const Filter = props => (
  <div className='filter'>
    <select {...props}>
      { options.map(o => <option key={o.value} {...o} />) }
    </select>
  </div>
)

export default memo(Filter)